import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { useLocation } from 'react-router-dom'
import { Service } from '../service/Service';
import { RECUPERAR_PASSWORD } from './../genericos/Uris'
import { MensajeAdvertencia } from '../components/mensajes/Mensajes';
import { Divider } from 'primereact/divider';
import { Dialog } from 'primereact/dialog';
import ErrorSistema from '../components/error/ErrorSistema';
import Spinner from '../components/loader/Spinner';
import Environment from '../Environment';

const getRoute = Environment();

const RecuperarPassword = (/*{ setVerificarEstatus }*/) => {
    const recuperarPasswordService = new Service()

    let history = useHistory();
    const location = useLocation();
    //---------------------| Lista de variables |---------------------
    const [oldPassword, setOldPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [titleParam, setTitleParam] = useState('')
    // eslint-disable-next-line
    const [emailParam, setEmailParam] = useState('')
    const [cargar, setCargar] = useState(false)
    const [mostrarDialogo, setMostrarDialogo] = useState(false)
    //--> Mensajes
    const [mensajeDialogo, setMensajeDialogo] = useState('')
    const [mensaje, setMensaje] = useState('')
    //--> Mensaje back-end
    const [errorSistema, setErrorSistema] = useState(false)
    const [token, setToken] = useState('')
    const [estatus, setEstatus] = useState(false)

    useEffect(() => {
        setCargar(true)
        // console.log('useeffect')
        // console.log(location.search); 
        let splitted = location.search.split('=', 2);
        //--> Guardar token
        setToken(splitted[1])
        // console.log(splitted[1])

        if (splitted[1] !== undefined) setTitleParam(splitted[1])
        setTimeout(() => { setCargar(false) }, 1000);
        // eslint-disable-next-line
    }, []);

    //---------------------| Funciones para password |---------------------
    // eslint-disable-next-line
    const expresionPassword = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#\$+=])(?!.*?[<>])/i

    const header = <h6>Elije una contraseña</h6>;
    const footer = (
        <>
            <Divider />
            <p className="mt-2">Sugerencias</p>
            <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: '1.5' }}>
                <li>Un número</li>
                <li>Una mayúscula</li>
                <li>Una minúscula</li>
                <li>Un caracter como : #, $, +, =</li>
                <li>Mínimo 8 caracteres</li>
            </ul>
        </>
    );

    //---------------------| Funcion principal |---------------------
    const recuperarPassword = async (e) => {
        e.preventDefault()

        // --> Validar antes de enviar
        if (oldPassword.length < 8) {
            setMensaje("La contraseña es muy corta")
            setTimeout(() => { setMensaje('') }, 3000)
            return
        }
        if (newPassword.length < 8) {
            setMensaje("La contraseña muy corta")
            setTimeout(() => { setMensaje('') }, 3000)
            return
        }
        if (emailParam.length < 0) {
            setMensaje("Email requerido")
            setTimeout(() => { setMensaje('') }, 3000)
            return
        }
        if (oldPassword !== newPassword) {
            setMensaje("Las contraseñas son diferentes")
            setTimeout(() => { setMensaje('') }, 3000)
            return
        }
        if (!expresionPassword.test(oldPassword)) {
            setMensaje("Contraseña no valida")
            setTimeout(() => { setMensaje('') }, 3000)
            return
        }

        // --> Preparar objeto
        recuperarPasswordService.baseUrl = `${getRoute}/${RECUPERAR_PASSWORD}`
        // recuperarPasswordService.baseUrl = `${recuperarPasswordService.baseUrl}${RECUPERAR_PASSWORD}`
        recuperarPasswordService.config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }
        //--> Enviar objeto a back-end
        setCargar(true)
        try {
            console.log(recuperarPasswordService.baseUrl)
            const data = await recuperarPasswordService.create({ newPassword: oldPassword })
            console.log(data)

            setEstatus(true)
            setMensajeDialogo("Su contraseña se actualizó correctamente. Ahora ya puedes ingresar al sistema con su nueva contraseña.")
            setMostrarDialogo(true)
        } catch (error) {
            setEstatus(false)
            if (error.response === undefined) { setErrorSistema(true) }
            if (error.response.status === 500) { setErrorSistema(true) }
            if (error.response.status === 401 || error.response.status === 400) {
                setMostrarDialogo(true)
                setMensajeDialogo("Este link ya no es válido, por favor haga una nueva solicitud.")
            }
        } finally { setCargar(false) }
    }

    useEffect(() => { return () => { setCargar(false) } }, [])

    const envioExitoso = () => {
        setMostrarDialogo(false)
        history.push("/")
    }

    const botonDialogo = (
        <>
            <Button label="Aceptar" icon="pi pi-check" onClick={estatus ? envioExitoso : () => { setMostrarDialogo(false) }} />
        </>
    );

    return (
        <>
            {cargar && (<Spinner />)}
            {!cargar && !errorSistema && (
                <div className='flex justify-content-center'>
                    <div className='card w-30rem'>
                        <h5 className="text-center"> {titleParam ? "Escribe tu contraseña" : "Recupear contraseña"} </h5>
                        <form onSubmit={recuperarPassword}>
                            <div className="flex justify-content-center flex-wrap mt-4">
                                <div className="grid p-fluid">
                                    <div className="col-12 md:col-10">
                                        <label htmlFor='oldpassword' >Contraseña</label>
                                        <Password
                                            value={oldPassword} onChange={(e) => setOldPassword(e.target.value)}
                                            header={header} footer={footer} className="w-18rem" maxLength={150}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-content-center flex-wrap mt-3">
                                <div className="grid p-fluid">
                                    <div className="col-12 md:col-10">
                                        <label htmlFor='newpassword'>Confirmar contraseña </label>
                                        <Password id='newpassword' className="w-18rem" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} feedback={false}  maxLength={150}/>
                                    </div>
                                </div>
                            </div>
                            {mensaje && <MensajeAdvertencia>{mensaje}</MensajeAdvertencia>}
                            <div className="flex justify-content-center flex-wrap mt-3">
                                <Button label="Enviar" type="submit" className="w-5" />
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {errorSistema && (<ErrorSistema />)}
            <Dialog
                header="¡Atención!" visible={mostrarDialogo} style={{ width: '50vw' }}
                onHide={() => setMostrarDialogo(false)} footer={botonDialogo} >
                {mensajeDialogo}
            </Dialog>
        </>
    )
}

export default RecuperarPassword
